import {
    AUTHENTICATING_PARDOT_REQUEST, AUTHENTICATING_PARDOT_SUCCEDDED, AUTHENTICATING_PARDOT_FAILED,
    UPDATING_PARDOT_REQUEST, UPDATING_PARDOT_SUCCEDDED, UPDATING_PARDOT_FAILED
} from '../actionTypes.jsx';
import axios from 'axios';
import {activatingIntegrationSuccedded, 
  integrationAuthExpired } from '../integrations';

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
const PARDOT_BASE_URL = `${apiUrl}/api/2.0/integrations/pardot`

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: PARDOT_BASE_URL,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}
  
function authenticatingAccount(){
  return {
    type: AUTHENTICATING_PARDOT_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_PARDOT_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_PARDOT_FAILED,
    payload: error
  }
}

/**
* Update pardot configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: PARDOT_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, 'pardot'));
      dispatch(updatingConfigurationFailed(error.errors))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_PARDOT_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_PARDOT_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_PARDOT_FAILED,
    payload: error
  }
}